import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { RoleGate } from './components/RoleGate';
import { ROLE_ACCESS } from './lib/role-access';
import { AdminPage } from './pages/AdminPage';
import { BillingPage } from './pages/BillingPage';
import { ClinicalTemplateLibraryPage } from './pages/ClinicalTemplateLibraryPage';
import { DashboardPage } from './pages/DashboardPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { HistoryPage } from './pages/HistoryPage';
import { NewStudyPage } from './pages/NewStudyPage';
import { PatientFormPage } from './pages/PatientFormPage';
import { PatientsPage } from './pages/PatientsPage';
import { ReceptionPage } from './pages/ReceptionPage';
import { ReportPage } from './pages/ReportPage';
import { StudiesPage } from './pages/StudiesPage';
import { StudyDetailPage } from './pages/StudyDetailPage';
import { TechnicalPage } from './pages/TechnicalPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'patients', element: <PatientsPage /> },
      { path: 'patients/new', element: <RoleGate roles={ROLE_ACCESS.patientManage}><PatientFormPage /></RoleGate> },
      { path: 'patients/:id', element: <PatientFormPage /> },
      { path: 'studies', element: <StudiesPage /> },
      { path: 'studies/new', element: <RoleGate roles={ROLE_ACCESS.studyCreate}><NewStudyPage /></RoleGate> },
      { path: 'studies/:id', element: <StudyDetailPage /> },
      { path: 'studies/:id/reception', element: <RoleGate roles={ROLE_ACCESS.reception}><ReceptionPage /></RoleGate> },
      { path: 'studies/:id/technical', element: <RoleGate roles={ROLE_ACCESS.technicalCapture}><TechnicalPage /></RoleGate> },
      { path: 'studies/:id/report', element: <ReportPage /> },
      { path: 'studies/:id/documents', element: <DocumentsPage /> },
      { path: 'studies/:id/history', element: <HistoryPage /> },
      { path: 'work/technical', element: <RoleGate roles={ROLE_ACCESS.technical}><StudiesPage presetRole="TECNICA" /></RoleGate> },
      { path: 'work/medical', element: <RoleGate roles={ROLE_ACCESS.medical}><StudiesPage presetRole="MEDICO" /></RoleGate> },
      { path: 'clinical-templates', element: <RoleGate roles={ROLE_ACCESS.clinicalTemplates}><ClinicalTemplateLibraryPage /></RoleGate> },
      { path: 'work/documents', element: <RoleGate roles={ROLE_ACCESS.documents}><StudiesPage presetState="PEND_ENVIO" /></RoleGate> },
      { path: 'work/billing', element: <RoleGate roles={ROLE_ACCESS.billing}><BillingPage /></RoleGate> },
      { path: 'history', element: <HistoryPage global /> },
      { path: 'admin', element: <RoleGate roles={ROLE_ACCESS.admin}><AdminPage /></RoleGate> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
